<mat-card>
  <div class="row" style="text-align: center;">
    <div class="col-md-4 pointer" *ngFor="let module of modules" (click)="navigate(module)">
      <div *ngIf="canAccessAction(module?.moduleLink)">
        <img [src]="module.moduleIcon" style="width: 40px; height: 40px;border-radius: 40px" />
        <h4>{{module.moduleName}} </h4>
      </div>
    </div>
  </div>
</mat-card>